import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { formatDocumentTitle } from '@/lib/pageTitles';

/** Syncs `document.title` to "{page} | Halalin" from the current route. */
export function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = formatDocumentTitle(pathname);
  }, [pathname]);

  return null;
}
